import React from "react";
import "./style.scss";
import { useAppDispatch, useAppSelector } from "../../../hooks/app";
import { getRequestFormData, setRequestFormData } from "../../../store/slices/request-signature.slice";
function StepSelectFlight({ flights }: { flights: any }) {

  const requestFormData = useAppSelector(getRequestFormData)
  const dispatch = useAppDispatch()

  const handleFlightsSelect = (e: any) => {
    if (e.target.checked) {
      const flights = requestFormData?.flightId
      dispatch(setRequestFormData({
        flightId: Array.from(
          new Set([...flights, e.target.value])
        )
      }))
    } else {
      const flights = requestFormData?.flightId?.filter((id: string) => id !== e.target.value)
      dispatch(setRequestFormData({ flightId: flights }))
    }
  }
  return (
    <div className="signature_step__one">
      <h3 className="heading3 text-center">
        Select the flight(s) that you want to have signed.
      </h3>

      <ul className="flights_list">
        {flights?.map((f: any) => (
          <li key={f?._id} className="item">
            <label className="checkbox">
              {f?.flightNumber || "Unknown Flight"}
              <input type="checkbox" value={f?._id} checked={requestFormData?.flightId?.includes(f?._id)} onChange={handleFlightsSelect} />
              <span className="checkmark"></span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default StepSelectFlight;
